import "./OcipError.css";
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Table, Modal } from 'react-bootstrap';
import { getIvDataIndex } from "../../utils/ivErrorDataUtils";

// 비트맵 정의
const AlarmModalData = {
  1: {
    title: "3030 (Operating_mode)",
    rows: [
      { bit: "0x00", desc: "System initialization", code: "00H" },
      { bit: "0x01", desc: "Waiting", code: "01H" },
      { bit: "0x02", desc: "Pre-detection", code: "02H" },
      { bit: "0x03", desc: "Normal", code: "03H" },
      { bit: "0x04", desc: "Error", code: "04H" },
      { bit: "0x05", desc: "Permanent error", code: "05H" },
      { bit: "0x06", desc: "Aging", code: "06H" },
      { bit: "0x07", desc: "DSP Burning", code: "07H" },
      { bit: "0x08", desc: "ARM Burning", code: "08H" }
    ]
  },

  2: {
    title: "3029 (DSP_error_code)",
    rows: [
      { bit: "Bit16", desc: "Remote Off", code: "0x00010000" },
      { bit: "Bit17", desc: "reserve", code: "0x00020000" },
      { bit: "Bit18", desc: "SPI Communication Fail", code: "0x00040000" },
      { bit: "Bit19", desc: "reserve", code: "0x00080000" },
      { bit: "Bit20", desc: "Frequency Consistent Fault", code: "0x00100000" },
      { bit: "Bit21", desc: "GFCI Device Fault", code: "0x00200000" },
      { bit: "Bit22", desc: "Voltage Consistent Fault", code: "0x00400000" },
      { bit: "Bit23", desc: "GFCI Over Fault", code: "0x00800000" },
      { bit: "Bit24", desc: "reserve", code: "0x01000000" },
      { bit: "Bit25", desc: "reserve", code: "0x02000000" },
      { bit: "Bit26", desc: "reserve", code: "0x04000000" },
      { bit: "Bit27", desc: "reserve", code: "0x08000000" },
      { bit: "Bit28", desc: "reserve", code: "0x10000000" },
      { bit: "Bit29", desc: "reserve", code: "0x20000000" },
      { bit: "Bit30", desc: "reserve", code: "0x40000000" },
      { bit: "Bit31", desc: "reserve", code: "0x80000000" }
    ]
  },
  3: {
    title: "3036 (ARM_error_code)",
    rows: [
      { bit: "Bit0", desc: "Clock Warning", code: "0x0001" },
      { bit: "Bit1", desc: "Fan4 Lock", code: "0x0002" },
      { bit: "Bit2", desc: "Fan5 Lock", code: "0x0004" },
      { bit: "Bit3", desc: "Fan7 Lock", code: "0x0008" },
      { bit: "Bit4", desc: "Fan8 Lock", code: "0x0010" },
      { bit: "Bit5", desc: "Lighting Warning", code: "0x0020" },
    ]
  },
  4: {
    title: "3027 (DSP_alarm_code)",
    rows: [
      { bit: "Bit0", desc: "FanA Lock", code: "0x0001" },
      { bit: "Bit1", desc: "FanB Lock", code: "0x0002" },
      { bit: "Bit2", desc: "FanC Lock", code: "0x0004" },
      { bit: "Bit3", desc: "Zero Power", code: "0x0008" },
      { bit: "Bit4", desc: "Array Warning", code: "0x0010" },
    ]
  },
  5: {
    title: "3036 (ARM_alarm_code)",
    rows: [
      { bit: "Bit0", desc: "Clock Warning", code: "0x0001" },
      { bit: "Bit1", desc: "Fan4 Lock", code: "0x0002" },
      { bit: "Bit2", desc: "Fan5 Lock", code: "0x0004" },
      { bit: "Bit3", desc: "Fan7 Lock", code: "0x0008" },
      { bit: "Bit4", desc: "Fan8 Lock", code: "0x0010" },
      { bit: "Bit5", desc: "Lighting Warning", code: "0x0020" },
    ]
  },
  6: {
    title: "3028 (DSP_error_code)",
    rows: [
      { bit: "Bit0",  desc: "Grid Volt Low", code: "0x0001" },
      { bit: "Bit1",  desc: "Grid Volt High", code: "0x0002" },
      { bit: "Bit2",  desc: "Grid Frequency Low", code: "0x0004" },
      { bit: "Bit3",  desc: "Grid Frequency High", code: "0x0008" },
      { bit: "Bit4",  desc: "Bus Volt Low", code: "0x0010" },
      { bit: "Bit5",  desc: "Bus Volt High", code: "0x0020" },
      { bit: "Bit6",  desc: "Bus Volt Unbalance", code: "0x0040" },
      { bit: "Bit7",  desc: "Isolation Fault", code: "0x0080" },
      { bit: "Bit8",  desc: "PV Current High", code: "0x0100" },
      { bit: "Bit9",  desc: "Hard Inverter Current Over", code: "0x0200" },
      { bit: "Bit10", desc: "Inverter Current Over", code: "0x0400" },
      { bit: "Bit11", desc: "Inverter DC Current Over", code: "0x0800" },
      { bit: "Bit12", desc: "Ambient Temperature Over", code: "0x1000" },
      { bit: "Bit13", desc: "Sink Temperature Over", code: "0x2000" },
      { bit: "Bit14", desc: "AC Relay Fault", code: "0x4000" },
      { bit: "Bit15", desc: "Reserve", code: "0x8000" }
    ]
  },
};

const OcipError = ({ SelInverter }) => {
  const ivData = useSelector((state) => state.ivData || {});
  const [openModalNum, setOpenModalNum] = useState(null);
  const closeModal = () => setOpenModalNum(null);
  const dataIndex = getIvDataIndex(ivData, SelInverter);

  const getOcipErrorValue = (fieldIndex, fallback = null) => {
    if (dataIndex === -1) return fallback;
    return ivData?.Error?.[dataIndex]?.[fieldIndex] ?? fallback;
  };

  const parseBitFlags = (value) => {
    const flags = {};
    for (let i = 15; i >= 0; i--) {
      flags[`Bit${i}`] = (value & (1 << i)) !== 0;
    }
    return flags;
  };

  const isStatusAbnormal = (type, value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return false;

    // 비트 플래그 기반 처리
    if (type === "operatingMode") { // 3030 (Operating_mode)
      // 정상 상태는 Bit3만 1인 경우 => 0x0008
      return numericValue !== 0x0008;
    }

    // 나머지 레지스터는 어떤 비트든 1이 있으면 비정상
    return numericValue !== 0;
  };

  const renderModalContent = () => {
    const modal = AlarmModalData[openModalNum];
    if (!modal) return null;

    const valueMap = {
      1: getOcipErrorValue(4),
      2: getOcipErrorValue(1),
      3: getOcipErrorValue(3),
      4: getOcipErrorValue(0),
      5: getOcipErrorValue(3),
      6: getOcipErrorValue(2),
    };


    const selectedValue = valueMap[openModalNum];
    const activeBits = parseBitFlags(selectedValue);



    return (
      <>
        <Modal.Header closeButton>
          <Modal.Title>{modal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered size="sm">
            <tbody>
              {modal.rows.map((row, idx) => {
                const isActive = activeBits[row.bit.trim()];
                return (
                  <tr key={idx} className={isActive ? "active-row" : ""}>
                    <td>{row.bit}</td>
                    <td>{row.desc}</td>
                    <td>{row.code}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            닫기
          </Button>
        </Modal.Footer>
      </>
    );
  };

  return (
    <div className="status-list-container">
      <div className="status-list">
        {[
          { label: "3030 (Operating_mode)", type: "operatingMode", fieldIndex: 4, num: 1 },
          { label: "3029 (DSP_error_code)", type: "dspErrorHigh", fieldIndex: 1, num: 2 },
          { label: "3036 (ARM_error_code)", type: "armErrorCode", fieldIndex: 3, num: 3 },
          { label: "3027 (DSP_alarm_code)", type: "dspAlarmCode", fieldIndex: 0, num: 4 },
          { label: "3036 (ARM_alarm_code)", type: "armAlarmCode", fieldIndex: 3, num: 5 },
          { label: "3028 (DSP_error_code)", type: "dspErrorLow", fieldIndex: 2, num: 6 },
        ].map(({ label, type, fieldIndex, num }) => {
          const value = getOcipErrorValue(fieldIndex);

          const isAbnormal = isStatusAbnormal(type, value);

          return (
            <div key={num} className="status-item">
              <span className="status-value">
                {label}: {value ?? "N/A"}
              </span>
              <button onClick={() => setOpenModalNum(num)}>
                <span className={isAbnormal ? "blinking-icon" : ""}>
                  {isAbnormal ? "🔴" : "🟢"}
                </span>
              </button>
            </div>
          );
        })}
      </div>

      {openModalNum !== null && (
        <Modal show onHide={closeModal} size="lg">
          {renderModalContent()}
        </Modal>
      )}
    </div>
  );
};

export default OcipError;
